import { URLS } from "../Maps";

const excludedPaths = [
  URLS.REMIX,
  URLS.STUDIO,
  URLS.OVERWOLF,
  URLS.ALLSTAR_GAMERS_CLUB,
  "/partner/claim",
  "/partner/signup",
  "/mobile-app-link",
  "/authenticate/mobile",
  "/iframe",
  "/start",
  "/invite",
  // The feature pages deliberately keep the normal header and sidebar, so they
  // are not excluded here.
  "/iframe-demo",
];

const pathExcludesNavigation = (path: string) => {
  return (
    excludedPaths.includes(path) ||
    path.match("/signup") ||
    path.match("/register") ||
    path.match("/login") ||
    path.match("/reset") ||
    path.match("/oauth") ||
    path.match("/remix") ||
    path.match("/welcome") ||
    path.startsWith(URLS.SETUP)
  );
};

/**
 * Pages the legacy chrome hid itself from but the new nav is happy on. Studio
 * was excluded because the old sidebar crowded it, not because the page wants
 * no navigation, and being the one screen with no way back out is what makes it
 * feel like a separate product.
 *
 * Kept apart from excludedPaths so the control cohort's Sidebar and old header
 * still skip these exactly as they do today.
 */
const NEW_NAV_INCLUDES: string[] = [URLS.STUDIO];

const newNavExcludesNavigation = (path: string) =>
  !NEW_NAV_INCLUDES.includes(path) && pathExcludesNavigation(path);

export { pathExcludesNavigation, newNavExcludesNavigation };
